import { InvoiceProvider, useInvoice } from '../../common/InvoiceProvider';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  MenuItem,
  Select,
  Divider,
} from '@mui/material';
import Spinner from '../../Spinner';
import intl from 'components/i18n/ReactIntlWrapper';
import ErrorSummary from '../../common/ErrorSummary';
import PdfViewer from 'components/common/PdfRenderer';
import { WorkflowProvider } from 'components/Workflow/WorkflowContext';
import AccountsPayableForm from './AccountsPayableForm';

const InvoiceDetailAccountsPayableContent = ({ onlyView = false }) => {
  const {
    billFromPersonas,
    isBillFromPersonasLoading,
    setInput,
    input,
    isLoading,
    errors,
    setErrors,
  } = useInvoice();

  const handlePersonaChange = (e) => {
    setInput({
      ...input,
      idFrom: e,
      from: billFromPersonas.find((persona) => persona.id === e).name,
    });
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`idFrom`]: '',
    }));
  };

  return (
    <Box sx={{ mt: 4, px: 2 }}>
      <Card variant="outlined">
        {isLoading && <Spinner />}
        <CardHeader
          title={
            <Typography color="primary" variant="h2">
              Invoice Detail
            </Typography>
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid sx={{ xs: 12 }}>
              <ErrorSummary errors={errors} showEverything={true} />
            </Grid>

            <Grid sx={{ xs: 12 }}>
              <Typography
                sx={{ mt: errors?.idFrom && errors?.idFrom !== 'missing confidence' ? -3 : 0 }}
                color={errors?.idFrom ? 'error' : 'primary'}
                variant="body2"
              >
                {errors?.idFrom && errors?.idFrom !== 'missing confidence' && errors?.idFrom}
              </Typography>

              <Select
                id="idFrom"
                name="idFrom"
                value={input?.idFrom || ''}
                fullWidth
                displayEmpty
                size="small"
                onChange={(e) => handlePersonaChange(e.target.value)}
                error={Boolean(errors?.idFrom)}
                disabled={isBillFromPersonasLoading || onlyView}
              >
                <MenuItem disabled value="">
                  <em>{intl.get('newInvoice.invoiceSelectProfile')}</em>
                </MenuItem>
                {billFromPersonas?.map((persona) => (
                  <MenuItem key={persona.id} value={persona.id}>
                    {persona.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>

          <Divider sx={{ my: 3 }} />

          {input ? (
            <Grid container spacing={2} alignItems="flex-start" sx={{ width: '100%' }}>
              <Grid size={{ xs: 5, md: 5, sm: 5, lg: 5, xl: 5 }} sx={{ minWidth: 0 }}>
                {(input?.attachments || (input?.fileUri && input?.fileUri !== '')) && (
                  <Box mb={3}>
                    <PdfViewer
                      file={input['attachments']?.[0]}
                      dataURI={input['attachments']?.[0]?.dataUri}
                    />
                  </Box>
                )}
              </Grid>
              <Grid size={{ xs: 7, md: 7, sm: 7, lg: 7, xl: 7 }} sx={{ minWidth: 0 }}>
                <AccountsPayableForm onlyView={onlyView} />
              </Grid>
            </Grid>
          ) : (
            <Spinner />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

const InvoiceDetailAccountsPayable = ( { onlyView = false } ) => {
  return (
    <InvoiceProvider review={true}>
      <WorkflowProvider moduleId={onlyView?4:5}>
        <InvoiceDetailAccountsPayableContent onlyView={onlyView} />
      </WorkflowProvider>
    </InvoiceProvider>
  );
};

export default InvoiceDetailAccountsPayable;
